import { TypedJSONObject } from '../types';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { clientVersion } from '@trello/config';
import { QueryPublicPluginsArgs } from '../generated';

export const publicPluginsResolver = async (
  organization: {
    id: string;
  },
  args: QueryPublicPluginsArgs,
  context: object,
  info: QueryInfo,
): Promise<TypedJSONObject> => {
  let model = null;
  const queryParams = args?.preferredLocales
    ? new URLSearchParams({
        preferredLocales: args.preferredLocales,
      })
    : null;
  const apiUrl = queryParams
    ? `/1/plugins/public?${queryParams.toString()}`
    : '/1/plugins/public';

  try {
    const response = await fetch(apiUrl, {
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

    if (response.ok) {
      model = await response.json();
    } else {
      if (response.status === 404) {
        model = null;
      } else {
        throw new Error(
          `An error occurred while resolving a GraphQL query. (status: ${response.status}, statusText: ${response.statusText})`,
        );
      }
    }

    return model ? prepareDataForApolloCache(model, info) : model;
  } catch (err) {
    console.error(err);
    return model;
  }
};

export const pluginCategoriesResolver = async (
  obj: object,
  args: object,
  context: object,
  info: QueryInfo,
) => {
  let model = null;

  const apiUrl = '/1/plugins/categories';

  try {
    const response = await fetch(apiUrl, {
      credentials: 'include',
      headers: {
        'X-Trello-Client-Version': clientVersion,
      },
    });

    if (response.ok) {
      model = await response.json();
    } else {
      if (response.status === 404) {
        model = null;
      } else {
        throw new Error(
          `An error occurred while resolving a GraphQL query. (status: ${response.status}, statusText: ${response.statusText})`,
        );
      }
    }

    return prepareDataForApolloCache(model, info);
  } catch (err) {
    console.error(err);
    return model;
  }
};
